// frontend/src/marketing/analytics.js
//
// Consent-gated analytics integration point for the public site. It is a no-op
// unless BOTH are true:
//   1. the visitor granted analytics cookies (CookieBanner → localStorage), and
//   2. a measurement endpoint is configured via VITE_ANALYTICS_ENDPOINT.
//
// This keeps us privacy-first by default: nothing is sent without consent, and
// nothing is sent at all until an endpoint is wired in. Swap the beacon body for
// your provider's call when you choose one.
import { COOKIE_CONSENT_KEY } from "../components/CookieBanner";

/** True only when the visitor has explicitly allowed analytics cookies. */
export function hasAnalyticsConsent() {
  try {
    const consent = JSON.parse(localStorage.getItem(COOKIE_CONSENT_KEY));
    return Boolean(consent && consent.analytics);
  } catch {
    return false;
  }
}

const ENDPOINT = import.meta.env.VITE_ANALYTICS_ENDPOINT;

/** Record a page view — only if consent was given and an endpoint is set. */
export function trackPageview(path) {
  if (!hasAnalyticsConsent() || !ENDPOINT) return;
  try {
    const body = JSON.stringify({ type: "pageview", path, ts: Date.now() });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, body);
    } else {
      fetch(ENDPOINT, { method: "POST", body, keepalive: true });
    }
  } catch {
    // Analytics must never break the page.
  }
}
